import {useQuery} from '@apollo/client';
import {useParams} from 'react-router-dom';
import {GetGoalContacts, GetGoalContactsVariables} from '../schema-types/GetGoalContacts';
import {GET_CONTACTS} from '../features/goals/goalsQueries';
import validateUUID from '../utils/validateUUID';

export default function useAccountContacts() {
  const {accountId} = useParams();

  const {
    loading: accountContactsLoading,
    data: accountContactsData,
    error: accountContactsError,
  } = useQuery<GetGoalContacts, GetGoalContactsVariables>(GET_CONTACTS, {
    variables: {
      accountId: validateUUID(accountId)!,
    },
  });

  return {
    accountContactsLoading,
    accountContactsData,
    accountContactsError,
  };
}
